// extracted by mini-css-extract-plugin
module.exports = {"steps":"_1jtHp1Q","tear":"_2ZzCM_e","inner":"_T0xZxSV","step":"_odZ3Rwu","left":"_1yl2qM0","right":"_35YIpmN","title":"_2EcnOJb","text":"_3gltzNc"};